import store from '@/store';
import axios from 'axios';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import { cloneDeep } from 'lodash';

type AbuseContentType = 'conversation' | 'user';

interface AbusePayload {
    type: AbuseContentType;
    id: number;
    explanation?: string;
}

interface IabuseActionDictionary {
    block: {
        user: number[],
    };
    hide: {
        conversation: number[],
        message: number[],
    };
    report: {
        conversation: number[],
        message: number[],
    };
}

@Module({name: 'Abuse', namespaced: true})
export default class Abuse extends VuexModule {
    public abuseActionDictionary: IabuseActionDictionary =  {
        block: {
            user: [],
        },
        hide: {
            conversation: [],
            message: [],
        },
        report: {
            conversation: [],
            message: [],
        },
    };

    @Mutation
    public RESET_ABUSE_STORE_STATE(): void {
        this.abuseActionDictionary = {
            block: {
                user: [],
            },
            hide: {
                conversation: [],
                message: [],
            },
            report: {
                conversation: [],
                message: [],
            },
        };
    }

    get isContentHidden() {
        return (contentType, contentId) => {
            return this.abuseActionDictionary.hide[contentType].includes(contentId);
        };
    }

    get isContentBlocked() {
        return (contentType, contentId) => {
            return this.abuseActionDictionary.block[contentType].includes(contentId);
        };
    }

    @Mutation
    public SET_ABUSE_ACTIONS_DICTIONARY(abuseActionDictionary: any) {
        this.abuseActionDictionary = abuseActionDictionary;
    }

    @Action
    public REPORT_CONTENT(payload: AbusePayload) {
        payload.explanation = 'blank';

        const abuseActionDictionaryCopy = cloneDeep(store.state.Abuse.abuseActionDictionary);

        if (abuseActionDictionaryCopy.report[payload.type].indexOf(payload.id) === -1) {
            abuseActionDictionaryCopy.report[payload.type].push(payload.id);
        }

        store.commit(Mutations.SET_ABUSE_ACTIONS_DICTIONARY, abuseActionDictionaryCopy);

        return axios.post(Endpoints.Abuse.REPORT_CONTENT, payload)
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public BLOCK_CONTENT(payload: AbusePayload) {
        const abuseActionDictionaryCopy = cloneDeep(store.state.Abuse.abuseActionDictionary);

        if (abuseActionDictionaryCopy.block[payload.type].indexOf(payload.id) === -1) {
            abuseActionDictionaryCopy.block[payload.type].push(payload.id);
        }

        store.commit(Mutations.SET_ABUSE_ACTIONS_DICTIONARY, abuseActionDictionaryCopy);

        return axios.put(Endpoints.Abuse.BLOCK_CONTENT, payload)
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public UNBLOCK_CONTENT(payload: AbusePayload) {
        const abuseActionDictionaryCopy = cloneDeep(store.state.Abuse.abuseActionDictionary);

        const index = abuseActionDictionaryCopy.block[payload.type].indexOf(payload.id);
        if (index !== -1) {
            abuseActionDictionaryCopy.block[payload.type].splice(index, 1);
        }

        store.commit(Mutations.SET_ABUSE_ACTIONS_DICTIONARY, abuseActionDictionaryCopy);

        return axios.delete(Endpoints.Abuse.BLOCK_CONTENT, { data: payload})
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public HIDE_CONTENT(payload: AbusePayload) {
        const abuseActionDictionaryCopy = cloneDeep(store.state.Abuse.abuseActionDictionary);

        if (abuseActionDictionaryCopy.hide[payload.type].indexOf(payload.id) === -1) {
            abuseActionDictionaryCopy.hide[payload.type].push(payload.id);
        }

        store.commit(Mutations.SET_ABUSE_ACTIONS_DICTIONARY, abuseActionDictionaryCopy);

        return axios.put(Endpoints.Abuse.HIDE_CONTENT, payload)
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public UNHIDE_CONTENT(payload: AbusePayload) {
        const abuseActionDictionaryCopy = cloneDeep(store.state.Abuse.abuseActionDictionary);

        const index = abuseActionDictionaryCopy.hide[payload.type].indexOf(payload.id);
        if (index !== -1) {
            abuseActionDictionaryCopy.hide[payload.type].splice(index, 1);
        }

        store.commit(Mutations.SET_ABUSE_ACTIONS_DICTIONARY, abuseActionDictionaryCopy);

        return axios.delete(Endpoints.Abuse.HIDE_CONTENT, { data: payload})
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}
